import { useEffect, useState } from "react";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../User/State/Auth/Action";
import Loader from "../../../User/Components/Loader/Loader";
import { getVendorProfile } from "../../State/Vendor/Action";

const DashboardLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const jwt = localStorage.getItem("jwt");
  const { vendorProfile } = useSelector((store) => store);

  useEffect(() => {
    // Fetch user details if JWT is available
    if (jwt) {
      dispatch(getVendorProfile())
    }
  }, [jwt, dispatch]);

  const handleToggle = () => setCollapsed(!collapsed);
  const handleLogout = () => {
    dispatch(logout())
    navigate("/")
    window.location.reload();
  };

  return <div className="flex h-screen w-screen overflow-hidden">
    <Sidebar collapsed={collapsed} onLogout={handleLogout} user={vendorProfile?.vendor} />
    <div className="flex flex-col flex-1 overflow-hidden">
      <Header onToggle={handleToggle} onLogout={handleLogout} user={vendorProfile?.vendor} loading={vendorProfile?.loading} />
      <main className="flex-1 overflow-y-auto bg-gray-250 p-2 md:p-4">
        {vendorProfile?.vendor ? children : <Loader />}
      </main>
    </div>
  </div>;
};

export default DashboardLayout;
